import Vue from "vue"
import Vuex from "vuex"

// Modules
import app from "./app"
import appAutoRefresh from "./app-auto-refresh"
import appConfig from "./app-config"
import appFilter from "./app-filter"
import appPermission from "./app-permission"
import authStore from "./auth"
import verticalMenu from "./vertical-menu"
import siteAccess from "./site-access"
import siteStore from "./site"
import commonStore from "./conmmon"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appAutoRefresh,
    appConfig,
    appFilter,
    appPermission,
    authStore,
    verticalMenu,
    siteAccess,
    siteStore,
    commonStore,
  },
  strict: process.env.DEV,
})
